
import { WorldCountry } from '../types';
import { portugalExpanded } from './portugalExpansion';

export const finalEuropeCountries8: WorldCountry[] = [
  portugalExpanded
];
